import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Actions
import { updateLoading } from "store/actions";

// Layout
import Layout from "layout";

// Pages
import Home from "pages/Home";
import About from "pages/About";
import Teams from "pages/Team";
import Events from "pages/Events";
import Forms from "pages/Forms";
import Submit from "pages/Submit";


// Components
import DocumentHead from "components/DocumentHead";
import Loader from "components/Shared/Loader";

const App = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.appReducer);

  useEffect(() => {
    setTimeout(() => {
      dispatch(updateLoading(false));
    }, 2000);
  }, [dispatch]);
  

  return (
    <div className="IEEE-KSB">
      <Loader loaded={!loading} />
      <DocumentHead />
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route index element={<Home />} />
            <Route path="*" element={<Layout />}>
              <Route path="about" element={<About />} />
              <Route path="team" element={<Teams />} />
              <Route path="events" element={<Events />} />
               <Route path="forms" element={<Forms />} /> 
              <Route path="submit" element={<Submit />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
